/* eslint-disable no-undef */
const basepath = '/admin';

export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
export const FEATURE_FORM_BUILDER =
  process.env.REACT_APP_FEATURE_FORM_BUILDER === 'true';

export const APICONSTANTS = Object.freeze({
  loginverify: '/token',
  login: '/login',
  logout: '/signout',
  ssoLogout: '/sso-signout',
  ssoLogin: '/api/sso/auth/microsoft',
  // Whether "Login with SSO" is offered at all (TGCLOUD-1853).
  ssoStatus: '/sso/status',

  //public-routes
  recaptcha: '/system-params/recaptcha',
  defaultTheme: '/system-params/default-theme',
  brandingFromLinkToken: '/system-params/branding-from-link-token',

  updatePedigreeDetails: '/pedigree/update/user',
  setProbandEmail: '/pedigree/proband/:user_id/email',
  getPedigreeDetails: '/pedigree/details/:familyId',
  getProbandDetails: '/proband',
  getProbandSubmittedDetails: '/proband/submitted',
  deleteProbandFamilyMember: '/proband/family/:user_id/:member_id',
  probandFamilyDetails: '/proband/family/:user_id',
  getProbandUsers: `/users/proband`,
  getProbandBrowse: `/users/proband/browse`,
  getProbandSearchIndex: `/users/proband/search-index`,
  getPersonFilterFields: `/users/proband/filter-fields`,
  getProbandFamilyList: `/users/proband/family-list`,
  setExternalFamilyIds: '/users/proband/:user_id/external-family-ids',
  setExternalPatientIds: '/users/person/:familyMemberId/external-patient-ids',
  setFamilyNote: '/users/proband/:user_id/family-note',
  labelConfigurations: '/users/label-configurations',
  getRiskRecords: '/risk-factor/records/:user_id',
  deleteRiskRecord: '/risk-factor/records/:id',
  savePrsRecord: '/risk-factor/prs',
  getPgsScore: '/risk-factor/pgs/score/:pgsId',
  searchPgsTraits: '/risk-factor/pgs/traits',
  searchPgsScores: '/risk-factor/pgs/search',
  computePrsFromVcf: '/risk-factor/prs/compute-poc',
  getCanriskPrsReference: '/risk-factor/prs/canrisk-reference',
  getProbandUsersFamilyIds: '/proband/familyIds',
  mergeFamily: '/proband/merge-families',
  mergePersonPreview: '/proband/merge-persons/preview',
  mergePersonCommit: '/proband/merge-persons/commit',
  migrateToNewFamily: '/proband/migrate-members/to-new-family',
  migrateToExistingFamily: '/proband/migrate-members/to-existing-family',
  searchPersons: '/pedigree/search-persons',
  checkMerge: '/proband/families/can-merge',
  savePedigreeConfig: '/proband/save-pedigree-config/:user_id',

  getFamiliesInfo: `/users/proband/:user_id/family`,
  getXMLData: '/users/proband/:user_id/xml',
  getGA4JsonData: '/users/proband/:user_id/json',
  getPhenopacketData: '/users/proband/:user_id/phenopacket',
  getCanRiskData: '/users/proband/:user_id/canrisk',
  calculateCanRiskScore: '/users/proband/:user_id/canrisk/calculate',
  fillCanRiskModal: '/users/proband/:user_id/canrisk/fillup',
  saveCanRiskIndividualData: '/users/proband/:user_id/canrisk/individual-data',
  updateTourSkip: '/users/update-tour-skip',

  savePedigree: 'proband/family-tree/:id',
  setTags: '/pedigree/tags',
  personTags: '/pedigree/person-tags',
  pedigreeCanvasSettings: '/pedigree/pedigree-settings',
  savePedigreeMemberDetails: '/pedigree/config/:user_id/member-details',
  updatePedigreeRelaiton: '/pedigree/config/:user_id/set-relation',

  //Pedigree
  chartProband: '/pedigree/:user_id/chart-proband',
  pedigreeConfig: '/pedigree/:user_id/pedigree-config',
  pedigreeConfigCustomPosition:
    '/pedigree/:user_id/pedigree-config-customPostion',
  pedigreeViews: '/pedigree/:user_id/views',
  pedigreeOverlayFacts: '/pedigree/:user_id/overlay-facts',
  pedigreeViewById: '/pedigree/:user_id/views/:id',

  deletePedigreeFamilyMember: '/pedigree/delete/:user_id/:member_id',
  // Count-only, for the Delete Person confirmation: care pathways are the one
  // consequence of a deletion that cannot be counted client-side.
  // What Delete Person will take with it — a dry run of the delete itself (TGCLOUD-1848).
  pedigreeDeleteImpact: '/pedigree/:user_id/delete-impact/:member_id',
  deleteStructuralProband: '/pedigree/:user_id/delete-structural-proband',
  promoteProband: '/pedigree/:user_id/promote-proband',
  reassignPedigreeMember: '/pedigree/:user_id/reassign-member',
  removeRelationInPedigree: '/pedigree/:user_id/remove-relation',

  createFamily: '/pedigree/createNewFamily',
  importPhenopacketPreview: '/pedigree-import/import_phenopacket_preview',
  importPhenopacket: '/pedigree-import/import_phenopacket',
  importInvitaeXmlPreview: '/pedigree-import/import_invitae_xml_preview',
  importInvitaeXml: '/pedigree-import/import_invitae_xml',

  getMessagesByConversationId: '/message/conversation/:conversationId',
  updateMessagesByConversationId:
    '/message/update/conversation/:conversationId',

  createConversation: '/conversation/create',
  getConversation: '/conversation/patient/:user_id',
  getPhysicanToSendMsg: '/conversation/send/:user_id',

  getAuditLogs: '/audit-log',
  getAuditLogFacets: '/audit-log/facets',
  getAuditLogDetail: '/audit-log/:id/detail',
  getRecordHistory: '/audit-log/record-history',
  getAuditLogsByFamilyMemberId: '/audit-log/:familyMemberId',

  deleteProbandPregnancy: '/proband/pregnancy/:user_id/:pregnancy_id',
  probandPregnanciesDetails: '/proband/pregnancy/:user_id',
  getPregnanciesInfo: `/users/proband/:user_id/pregnancy`,

  deleteUser: '/users/proband/:user_id',
  markStatusAsImported: '/users/proband/imported/:user_id',
  setupPatientAccess: '/users/proband/:user_id/setup-patient',

  generateLink: '/questionnaire-links/generate',
  getGeneratedLinks: '/questionnaire-links',
  revertToDraft: '/questionnaire-links/revert/draft',
  deactivateLink: '/questionnaire-links/update/deactivate',
  updateLinkSpecialties: '/questionnaire-links/update/specialties',
  sendLinkEmail: '/questionnaire-links/notify/email',

  issueFhqForProband: '/questionnaire-links/issue',
  getProbandFhqStatus: '/questionnaire-links/status/:probandId',
  applyFhq: '/questionnaire-links/apply/:probandId',
  discardFhq: '/questionnaire-links/discard/:probandId',

  getReferenceCode: '/reference-code',
  verifyReferenceCode: '/reference-code/verify',
  generateReferenceCode: '/reference-code/generate',

  generateLinkByPatient: '/questionnaire/generate-link',

  resetPasswordEmail: '/password/reset/email',
  resetPasswordToken: '/password/reset/token',
  resetPassword: '/password/reset',
  changePassword: '/users/password/update',

  questionCustomisations: '/settings/customisation',
  updateCustomisation: '/settings/customisation/update',
  labelsCustomisation: '/settings/customisation/labels',
  updateQuesCustomisation: '/settings/customisation/questions',
  setClinicianDiagnoses: '/settings/customisation/clinicianDiagnoses',
  getClinicianDiagnoses: '/settings/customisation/clinicianDiagnoses',
  editClinicianDiagnoses: '/settings/customisation/clinicianDiagnoses/:id',
  updateEthnicity: '/settings/customisation/ethnicity/update',
  bulkUpdateEthnicity: '/settings/customisation/ethnicity/bulk-update',
  getEthnicity: '/settings/customisation/ethnicity',
  updateReligion: '/settings/customisation/religion/update',
  bulkUpdateReligion: '/settings/customisation/religion/bulk-update',
  getReligion: '/settings/customisation/religion',
  updateReligionClassification:
    '/settings/customisation/religion/classification',

  updatePedigreeSetting: '/settings/pedigree/update',
  pedigreeSetting: '/settings/pedigree',
  labelDisplayPresets: '/settings/pedigree/label-presets',
  diseaseColourKey: '/settings/pedigree/colour-key',
  diseaseColourKeyList: '/settings/pedigree/colour-key/list',
  diseaseColourKeyBatch: '/settings/pedigree/colour-key/batch',
  anonymousPedigreesGlobal: '/settings/pedigree/anonymous-global',
  anonymousPedigreesPiiCount: '/settings/pedigree/anonymous-pii-count',
  pedigreeFieldLabels: '/settings/pedigree/field-labels',

  getPreferences: '/settings/preferences',
  updatePreferences: '/settings/preferences',

  // Settings > Lookups (TGCLOUD-1784). The arrow form rather than a ':listKey'
  // template, because these take two parameters and a chained double
  // `.replace()` at every call site is where a typo hides.
  lookups: '/settings/lookups',
  lookupList: (listKey) => `/settings/lookups/${listKey}`,
  lookupValues: (listKey) => `/settings/lookups/${listKey}/values`,
  lookupValueById: (listKey, id) => `/settings/lookups/${listKey}/values/${id}`,
  lookupReorder: (listKey) => `/settings/lookups/${listKey}/reorder`,
  lookupStandards: (listKey) => `/settings/lookups/${listKey}/standards`,
  lookupStandardById: (listKey, id) =>
    `/settings/lookups/${listKey}/standards/${id}`,
  lookupExport: (listKey) => `/settings/lookups/${listKey}/export`,
  lookupBundleExport: '/settings/lookups/export',
  lookupBundleImport: '/settings/lookups/import',
  lookupScan: (listKey) => `/settings/lookups/${listKey}/scan`,
  lookupAdopt: (listKey) => `/settings/lookups/${listKey}/adopt`,

  smtpDetails: '/settings/smtp',
  emailTemplates: '/settings/email-templates',
  checkEmailTemplate: '/settings/check-email-template',
  stripe: '/settings/stripe',
  stripeKeys: '/settings/stripe/keys',
  stripteProducts: '/settings/stripe/products',

  deleteEmailTemplates: '/settings/email-templates/:id',

  updateReminder: '/settings/update-reminder',
  getReminder: '/settings/reminder',

  // EMR feature
  adminEmrSettings: '/settings/admin/emr-settings',
  emrSettings: '/settings/emr-settings',
  emrSettingsStatus: '/emr-settings/status',
  emrIntegrationAccessToken: '/emr-settings/access-token?code=:code',
  emrIntegrationRefreshToken: '/emr-settings/refresh-token',

  inactivityLogoutDuration: '/settings/admin/inactivity-logout-duration',

  announcementsActive: '/announcements/active',
  announcementsAdmin: '/announcements/admin',
  announcements: '/announcements',
  announcementDismiss: (id) => `/announcements/${id}/dismiss`,
  announcementById: (id) => `/announcements/${id}`,

  // security monitor / lockdown
  monitorLogs: '/monitor/logs',

  // demo tenant
  demoStatus: '/demo/status',
  demoReset: '/demo/reset',

  // clinic-endpoints
  clinics: '/clinic-management/clinics',
  clinicMembers: '/clinic-management/members',
  clinicById: (id) => `/clinic-management/clinics/${id}`,
  clinicArchive: (id) => `/clinic-management/clinics/${id}/archive`,
  clinicRestore: (id) => `/clinic-management/clinics/${id}/restore`,
  appointmentTypes: '/clinic-management/appointment-types',
  appointmentTypeById: (id) => `/clinic-management/appointment-types/${id}`,
  appointmentTypeArchive: (id) =>
    `/clinic-management/appointment-types/${id}/archive`,
  appointmentTypeRestore: (id) =>
    `/clinic-management/appointment-types/${id}/restore`,
  sessionTemplates: '/clinic-management/session-templates',
  sessionTemplateById: (id) => `/clinic-management/session-templates/${id}`,
  sessionTemplateArchive: (id) =>
    `/clinic-management/session-templates/${id}/archive`,
  sessionTemplateRestore: (id) =>
    `/clinic-management/session-templates/${id}/restore`,
  generateSessions: (id) =>
    `/clinic-management/session-templates/${id}/generate`,
  sessions: '/clinic-management/sessions',
  sessionCancel: (id) => `/clinic-management/sessions/${id}/cancel`,
  sessionRestore: (id) => `/clinic-management/sessions/${id}/restore`,

  setCustomTheme: '/settings/theme',
  getCustomTheme: '/settings/theme',
  deleteThemeLogo: '/settings/theme',
  deleteThemeFavicon: '/settings/theme/favicon',

  generateLinkTokenExpireIn: `/settings/generate-link-token-expire-in`,

  getAllClients: '/admin/clients',
  createClient: '/admin/client/create',
  updateClient: '/admin/client/:_id/update',
  getUserGroups: '/admin/user-groups',
  getCurrentUserGroup: '/admin/user-group/current',
  updateExportPermission: '/admin/user-group/export',
  getExportSettings: '/admin/export-settings',
  deleteClient: '/admin/client/:_id',
  clientStatus: '/admin/client/:_id/status',
  // TGCLOUD-1844: bulk add, invites, licensing, trials
  bulkCreateClients: '/admin/clients/bulk',
  resendInvite: '/admin/client/:_id/resend-invite',
  licenceStatus: '/licence/status',
  licenceRequestExport: '/licence/request-export',
  licenceDeployment: '/licence/deployment',
  licenceReport: '/licence/report',
  licenceGroups: '/licence/groups',
  licenceGroupMembers: '/licence/groups/:id/members',
  licenceGroupSeatLimit: '/licence/groups/:id/seat-limit',
  licenceGroupSuspend: '/licence/groups/:id/suspend',
  licenceGroupUnsuspend: '/licence/groups/:id/unsuspend',
  licenceGroupDeleteData: '/licence/groups/:id/delete-data',
  licenceGroupExtend: '/licence/groups/:id/extend',
  licenceGroupConvert: '/licence/groups/:id/convert',
  licenceGroupRevertToTrial: '/licence/groups/:id/revert-to-trial',
  hostedSettings: '/licence/hosted/settings',
  hostedSignupCodes: '/licence/hosted/signup-codes',
  hostedSignupCodeRevoke: '/licence/hosted/signup-codes/:id/revoke',
  hostedLicences: '/licence/hosted/licences',
  hostedLicenceRevoke: '/licence/hosted/licences/:licenceId/revoke',
  trialConfig: '/trial/config',
  trialSignup: '/trial/signup',
  trialVerify: '/trial/verify',
  trialComplete: '/trial/complete',
  getPendingUsers: '/admin/pending-users',
  approveUser: '/admin/approve',
  rejectUser: '/admin/reject',

  dataExplorer: '/data-explorer',

  generateClientApi: '/admin/client/generate-api',
  revokeClientApi: '/admin/client/generate-api/:id',
  getClientApi: '/admin/client/apiStatus',

  formBuilderSchemas: '/form-builder/schemas',
  formBuilderGenerateLink: '/form-builder/generate-links',
  formBuilderGeneratedLinks: '/form-builder/links',
  formResponsesPath: `/form-builder/responses/:_id`,
  formResponsesDeactivatePath: `/form-builder/responses/:_id/deactivate`,
  formRevertToDraft: `/form-builder/revert-draft/:_id`,
  formExportResponse: `/form-builder/export/csv/:template_id`,
  formResponsesByFamilyMember:
    '/form-builder/responses/familyMember/:familyMemberId',
  formBuilderSchemasMappings: '/form-builder/schemas/:_id/mappings',

  // Risk score
  calculateGailRiskScore: '/risk-factor/calculateGailRiskScore',
  saveGailInputs: '/risk-factor/gail-inputs',
  getRiskFactor: '/risk-factor/:pid',

  getPersonLinkStatus: '/person-links/person/:familyMemberId',
  resolvePersonLink: '/person-links/resolve/:familyMemberId',
  searchPersonLinks: '/person-links/search',
  batchPersonLinkStatus: '/person-links/batch',
  createPersonLink: '/person-links',
  deletePersonLink: '/person-links/:id',
  syncPersonLinkSecondaries: '/person-links/sync-secondaries',
  geoReference: '/geo/reference',
  placesStatus: '/places/status',
  placesAutocomplete: '/places/autocomplete',
  placesDetails: '/places/details',

  //translation
  updateTranslation: '/translation',
  getTranslations: '/translation/:lang',

  // form builder feature
  formBuilderFeatureStatus: '/form-builder/status',

  pathwaysFeatureStatus: '/settings/features/pathways',
  pathwaysTemplates: '/pathways/templates',
  pathwayTemplateById: '/pathways/templates/:id',
  pathwayInstances: '/pathways/instances',
  pathwayInstanceById: '/pathways/instances/:id',
  pathwayInstanceMoveStage: '/pathways/instances/:id/stage',
  pathwayInstanceEvents: '/pathways/instances/:id/events',
  pathwayInstanceAdvance: '/pathways/instances/:id/advance',
  pathwayFamilyMembers: '/pathways/family-members',
  pathwayTestResults: '/pathways/test-results',
  pathwayAppointmentRecords: '/pathways/appointment-records',
  pathwayFormResponse: '/form-builder/responses/by-pathway-stage',
  // data explorer feature
  dataExplorerFeatureStatus: '/settings/data-explorer/status',
  clinicManagementFeatureStatus: '/settings/features/clinic-management',
  familyHistoryQuestionnaireFeatureStatus:
    '/settings/features/family-history-questionnaire',
  familyRecordManagementFeatureStatus:
    '/settings/features/family-record-management',
  carrierStatusInConditionFeatureStatus:
    '/settings/features/carrier-status-in-condition',
  siteDiseaseColourKeyFeatureStatus:
    '/settings/features/site-disease-colour-key',
  fhqSpecialityConfigFeatureStatus: '/settings/features/fhq-speciality-config',
  trakGeneApiFeatureStatus: '/settings/features/trakgene-api',
  specialties: '/settings/specialties',

  // chat feature
  chatFeature: '/settings/chat/status',
  getChatFeature: '/settings/chat/status/:userGroup',

  // System Features
  getSystemFeatures: '/settings/features',
  medicareFeature: '/settings/features/medicare',
  carrierScreenFeature: '/settings/features/carrierScreen',
  pedigreeLabelEditForGSA: '/settings/features/pedigree-label-edit-gsa',

  pedigree_v2: '/settings/features/pedigree_v2',

  // Student Account Registration Feature
  studentRegistration: '/settings/features/student-registration',

  canRiskSettings: '/settings/features/canrisk',

  // medicare Tyro Config
  tyroConfig: '/settings/tyro-config',

  patientEmailRegister: '/settings/patient-email-registration',
  recaptchaFeature: '/settings/recaptcha/status',
  googleTranslate: '/settings/google-translate',
  googleTranslateFeature: '/settings/google-translate/status',
  addressAutocompleteFeature: '/settings/address-autocomplete/status',
  addressDefaults: '/settings/address/defaults',

  // get all admin/user-group settings status
  getAllFeaturesSettings: '/settings/features/all',
  getAllGlobalFeaturesStatus: '/settings/global/features/status',

  //to get progress of every users for available froms
  formProgress: '/form-builder/progress-data',

  formBuilderWorkflowSchemas: '/form-builder/workflows',
  formUnlockAndReset: '/form-builder/workflows/unlock',

  // update patient selected userGroup
  setPatientSelectedUserGroup: '/users/patient/selected-usergroup',
  // switch active usergroup for client (non-patient) users
  switchUserGroup: '/users/client/switch-usergroup',
  clearDefaultUserGroup: '/users/client/clear-default-usergroup',
  uploadProfilePhoto: '/users/profile-photo',
  deleteProfilePhoto: '/users/profile-photo',
  getProfilePhoto: '/users/profile-photo',

  setDefaultLinkParameter: '/trakgene/linkparameters/default',
  getDefaultLinkParameter: '/trakgene/linkparameters/default',

  updateSystem: '/system-update/install',
  getCurrentVersion: '/system-update/current-version',
  checkSystemUpdate: '/system-update/check',
  systemDependencies: '/system-update/dependencies',
  releaseNotes: '/release-notes',
  releaseNotesAvailable: '/release-notes/available',
  releaseNotesSeen: '/release-notes/seen',
  terminologyVersion: '/terminology/version',
  // Per-system readiness: whether each code system actually holds rows, as
  // opposed to merely having a version row (TGCLOUD-1785).
  terminologyHealth: '/terminology/health',
  terminologyUpdateStatus: '/terminology/update/status',
  terminologyUpdateConfig: '/terminology/update/config',
  terminologyRevertOptions: '/terminology/update/revert-options',
  terminologyRevert: '/terminology/update/revert',
  terminologySystemsConfig: '/terminology/systems/config',
  toggleSystemUpdatePermission: '/system-update/client',

  // Virtual Assistant
  vaSettings: '/va/settings',
  vaHealth: '/va/health',
  // Fetch one directLaunch walkthrough definition (welcome tour).
  vaWalkthrough: '/va/walkthrough',
  // List the tours available on a screen (browsable help, no LLM).
  vaWalkthroughs: '/va/walkthroughs',
  vaOverlays: '/va/overlays',
  vaKb: '/va/kb/:persona',
  vaTranscribe: '/va/transcribe',
  vaSpeak: '/va/speak',

  //storage configs
  storageConfig: '/settings/storage-config',

  // Phenotypes
  phenotypes: '/phenotypes',
  getPhenotypesById: '/phenotypes/:user_id/:familyMemberId',
  updatePhenotype: '/phenotypes/:user_id/:familyMemberId', // Add this line
  deletePhenotypeById: '/phenotypes/:user_id/:familyMemberId',

  // Genotypes
  genotypes: '/genotypes',
  getGenotypesById: '/genotypes/:user_id/:familyMemberId',
  updateGenotype: '/genotypes/:user_id/:familyMemberId',
  deleteGenotypeById: '/genotypes/:user_id/:familyMemberId',
  pushVariantsToGenotype: '/genotypes/:user_id/:familyMemberId/variants/push',

  geneDiseaseByGene: '/terminology/gene-disease/by-gene/:geneSymbol',

  // GenCC curated gene-disease validity (TGCLOUD-1794). Read-only annotation;
  // every response carries `available` and the dataset version, because
  // "GenCC has no submission for this gene" and "we could not reach GenCC"
  // are different answers and must render differently.
  genccByGene: '/terminology/gencc/by-gene/:geneSymbol',
  genccByGenes: '/terminology/gencc/by-genes',
  genccDataset: '/terminology/gencc/dataset',

  // Mode-of-inheritance annotations for a batch of diseases. Gates whether the
  // pedigree analyzer may assert a Mendelian inheritance mode (TGCLOUD-1712).
  diseaseInheritance: '/terminology/inheritance',

  // Diagnoses
  diagnoses: '/diagnoses',
  getDiagnosesById: '/diagnoses/:user_id/:familyMemberId',
  deleteDiagnosesById: '/diagnoses/:user_id/:familyMemberId',

  medicareSave: '/medicare/file-data',
  deleleMedicareBill: '/medicare/file-data/:id',
  archiveMedicareBill: '/medicare/file-data/archive/:id',
  getMedicareInvoices: '/medicare/invoices',
  deleteMedicarePatientInvoice: '/medicare/invoices/:id',
  claimMedicarePatientInvoice: '/medicare/invoices/:id',
  updateMedicarePatientInvoice: '/medicare/invoices/update',
  medicareInvoiceMarker: '/medicare/invoice/manual-marker',
  // A fresh Tyro webhook key for one invoice (invoice lists never carry one).
  medicareInvoiceWebhookToken: '/medicare/invoices/:id/webhook-token',

  medicareOnlineTransactionHook:
    '/api/medicare-transactions/online-transaction',
  medicareClaimTransactionHook: '/api/medicare-transactions/transactions',

  saveCarrierScreenReports: '/carrier-screen/reports',
  deleteCarrierScreenReport: '/carrier-screen/reports/:id',
  getCarrierScreenReports: '/carrier-screen/reports',

  // clinical-notes
  referral: '/clinical-notes/referral',
  fileAttachment: '/clinical-notes/file',
  appointment: '/clinical-notes/appointment',
  consent: '/clinical-notes/consent',
  contact: '/clinical-notes/contact',
  sample: '/clinical-notes/sample',
  test: '/clinical-notes/test',
  treatment: '/clinical-notes/treatment',
  address: '/clinical-notes/address',
  clinicalNote: '/clinical-notes/clinical-note',
  process: '/clinical-notes/process',
  tissuePathology: '/clinical-notes/tissue-pathology',
  tissuePathologySearch: '/clinical-notes/tissue-pathology/search',
  treatmentSearch: '/clinical-notes/treatment/search',

  fetchAddressFlags: '/clinical-notes/address/:familyId/:familyMemberId',

  // account data deletion
  getDataOverview: `${basepath}/account/overview`,
  deleteAccountData: `${basepath}/account/delete`,

  //templates
  createTemplate: `/letter-template/create`,
  getTemplates: '/letter-template',
  getTemplateById: '/letter-template/:id',
  updateTemplate: '/letter-template/:id',
  publishTemplate: '/letter-template/:id/publish',
  unpublishTemplate: '/letter-template/:id/unpublish',
  // Deterministic Letter Merge v2 — schema-driven catalogue + governance
  getMergeFieldCatalogue: '/letter-template/merge-fields',
  validateTemplate: '/letter-template/validate',
  recordLetterGeneration: '/letter-template/generation',
  listLetterGenerations: '/letter-template/generation',
  getLetterGenerationById: '/letter-template/generation/:id',

  // desktop to cloud migration (admin-only operator tool)
  desktopMigrationTargetGroups: '/desktop-migration/target-groups',
  desktopMigrationPreview: '/desktop-migration/preview',
  desktopMigrationRuns: '/desktop-migration/runs',
  desktopMigrationRunById: '/desktop-migration/runs/:id',
  desktopMigrationVerificationCsv:
    '/desktop-migration/runs/:id/verification.csv',

  //bulk-import wizard
  importUpload: '/import/upload',
  importUploadById: '/import/upload/:uploadId',
  importGetUpload: '/import/uploads/:uploadId',
  importUploadReference: '/import/uploads/reference',
  importStorageStatus: '/import/storage-status',
  importStorageBrowse: '/import/storage-browse',
  importTus: '/import/tus',
  importSchema: '/import/schema',
  importTemplatesList: '/import/templates',
  importTemplateById: '/import/templates/:id',
  importJobs: '/import/jobs',
  importJobById: '/import/jobs/:id',
  importJobRerunPlan: '/import/jobs/:id/rerun-plan',
  importJobPreview: '/import/jobs/preview',
  importJobSkippedCsv: '/import/jobs/:id/skipped.csv',
  terminologySearch: '/terminology/search',

  //letters
  createLetter: `/letter/create`,
  getLetters: '/letter/familyMemberId/:familyMemberId',
  getLetterById: '/letter/:id',
  updateLetter: '/letter/:id',

  //security-group
  createSecurityGroup: '/security-group/create',
  getSecurityGroups: '/security-group/get',
  updateSecurityGroup: '/security-group/:id',

  // pedigree lock
  pedigreeLock: '/pedigree-lock',
  // person-level lock. Every route below this is family-scoped —
  // `/person-lock/:pedigreeId/:personId/...` and `/person-lock/:pedigreeId/batch/...`
  // — because `personId` on its own is the canvas-local pid (TGCLOUD-1767).
  // The old `personLockBatch` constant is gone with the unscoped path it named.
  personLock: '/person-lock'
});

export const CONSTANTS = Object.freeze({
  relations: {
    son: 'Son',
    daughter: 'Daughter',
    fullSister: 'Full Sister',
    halfSister: 'Half Sister',
    fullBrother: 'Full Brother',
    halfBrother: 'Half Brother',
    mother: 'Mother',
    father: 'Father',
    mothersMother: "Mother's Mother",
    mothersFather: "Mother's Father",
    fathersMother: "Father's Mother",
    fathersFather: "Father's Father",
    mothersBrother: "Mother's Brother",
    mothersSister: "Mother's Sister",
    fathersBrother: "Father's Brother",
    fathersSister: "Father's Sister",
    otherAffected: 'Other relative with disease/disorder',
    // TGCLOUD-1458. System-minted by the FHQ for a half-sibling's other parent.
    // Deliberately absent from `relationsOptions` — a patient must never be able to
    // pick a designation the system assigns. The XML wire string stays unchanged;
    // see the note on relationsMap in backend/util/constants.js.
    halfSiblingParent: "Half Sibling's Parent"
  },
  gender: {
    son: 'male',
    daughter: 'female',
    fullSister: 'female',
    halfSister: 'female',
    fullBrother: 'male',
    halfBrother: 'male',
    mother: 'female',
    father: 'male',
    mothersMother: 'female',
    mothersFather: 'male',
    fathersMother: 'female',
    fathersFather: 'male',
    mothersBrother: 'male',
    mothersSister: 'female',
    fathersBrother: 'male',
    fathersSister: 'female',
    otherAffected: 'unknown'
  },

  genderIdentity: {
    male: 'Male',
    female: 'Female',
    Indeterminate: 'Indeterminate',
    'Male - AFAB': 'Male - AFAB', //Female AFAB Assigned female at birth, identifying as male Square Mother
    'Male - UAAB': 'Male - UAAB', //Indeterminate UAAB VSC identifying as male Square Question
    'Female - AMAB': 'Female - AMAB', //Male AMAB Assigned male at birth, identifying as female Circle Father
    'Female - UAAB': 'Female - UAAB', //Indeterminate UAAB VSC identifying as female Circle
    'Non-binary/gender diverse - AFAB': 'Non-binary/gender diverse - AFAB', //Female AFAB Assigned female at birth, identifying as non-binary Diamond Mother
    'Non-binary/gender diverse - AMAB': 'Non-binary/gender diverse - AMAB', //Male AMAB Assigned male at birth, identifying as non-binary Diamond Father
    'Non-binary/gender diverse - UAAB': 'Non-binary/gender diverse - UAAB', //Indeterminate UAAB VSC, sex unassigned at birth - identifying as non-binary Diamond Question Prompt
    'Unknown/Not Stated Unknown': 'Unknown/Not Stated Unknown' //- Sex unknown or not stated or representing multiple persons of all sexes Diamond Question
  },

  genderIdentityOptions: [
    { label: 'Male', value: 'Male' },
    { label: 'Female', value: 'Female' },
    { label: 'Indeterminate', value: 'Indeterminate' },
    { label: 'Male - Assigned Female at Birth', value: 'Male - AFAB' },
    {
      label: 'Male -  Unspecified/Unknown Assigned at Birth',
      value: 'Male - UAAB'
    },
    { label: 'Female - Assigned Male at Birth', value: 'Female - AMAB' },
    {
      label: 'Female - Unspecified or Unknown Assigned at Birth',
      value: 'Female - UAAB'
    },
    {
      label: 'Non-binary/gender diverse -  Assigned Female at Birth',
      value: 'Non-binary/gender diverse - AFAB'
    },
    {
      label: 'Non-binary/gender diverse - Assigned Male at Birth',
      value: 'Non-binary/gender diverse - AMAB'
    },
    {
      label:
        'Non-binary/gender diverse - Unspecified or Unknown Assigned at Birth',
      value: 'Non-binary/gender diverse - UAAB'
    },
    { label: 'Unknown/Not Stated ', value: 'Unknown/Not Stated ' }
  ],

  adoptedMap: [
    { label: 'None', value: null },
    { label: 'Adopted In', value: 'adopted_in' },
    { label: 'Adopted Out', value: 'adopted_out' }
  ],

  fertilityMap: [
    { label: 'None', value: null },
    { label: 'Infertile', value: 'infertile' },
    { label: 'No Issue', value: 'fertile' }
  ],

  genderMappings: {
    Male: 'male',
    Female: 'female',
    Indeterminate: 'unknown',
    'Male - AFAB': 'female',
    'Male - UAAB': 'unknown',
    'Female - AMAB': 'male',
    'Female - UAAB': 'unknown',
    'Non-binary/gender diverse - AFAB': 'female',
    'Non-binary/gender diverse - AMAB': 'male',
    'Non-binary/gender diverse - UAAB': 'unknown',
    'Unknown/Not Stated Unknown': 'unknown'
  },

  tags: [
    { label: 'research project', tagColor: 'rgb(210, 221, 250)' },
    { label: 'clinical study', tagColor: 'rgb(211, 250, 210)' },
    { label: 'clinic', tagColor: 'rgb(250, 224, 210)' }
  ],

  linkStatusMap: {
    false: 'Expired',
    true: 'Active'
  },

  fhqStatus: {
    NOT_SENT: 'Not Sent',
    SENT: 'Sent',
    SUBMITTED: 'Submitted',
    APPLIED: 'Applied'
  },

  fhqStatusColors: {
    'Not Sent': { bg: '#eef1f4', fg: '#5a6a7a' },
    Sent: { bg: '#fff4e0', fg: '#8a5a00' },
    Submitted: { bg: '#e4f3f6', fg: '#0e7186' },
    Applied: { bg: '#e6f6ec', fg: '#1b7a43' }
  },

  pedigreeState: {
    unchanged: 'UN_CHANGED',
    modified: 'MODIFIED'
  },

  //languages
  languages: [
    { value: 'en_GB', label: 'English (UK)' },
    { value: 'en', label: 'English (US)' },
    { value: 'en_AU', label: 'English (AUS)' },
    { value: 'en_CA', label: 'English (CAN)' },
    { value: 'af', label: 'Afrikaans' },
    { value: 'sq', label: 'Shqip' },
    { value: 'am', label: 'አማርኛ' },
    { value: 'ar', label: 'العربية' },
    { value: 'hy', label: 'Հայերեն' },
    { value: 'as', label: 'অসমীয়া' },
    { value: 'ay', label: 'Aymar aru' },
    { value: 'az', label: 'Azərbaycan' },
    { value: 'bm', label: 'Bamanankan' },
    { value: 'eu', label: 'Euskara' },
    { value: 'be', label: 'Беларуская' },
    { value: 'bn', label: 'বাংলা' },
    { value: 'bho', label: 'भोजपुरी' },
    { value: 'bs', label: 'Bosanski' },
    { value: 'bg', label: 'Български' },
    { value: 'ca', label: 'Català' },
    { value: 'ceb', label: 'Cebuano' },
    { value: 'zh-CN', label: '中文（简体）' },
    { value: 'zh-TW', label: '中文（繁體）' },
    { value: 'co', label: 'Corsu' },
    { value: 'hr', label: 'Hrvatski' },
    { value: 'cs', label: 'Čeština' },
    { value: 'cy', label: 'Cymraeg' },
    { value: 'da', label: 'Dansk' },
    { value: 'dv', label: 'ދިވެހި' },
    { value: 'doi', label: 'डोगरी' },
    { value: 'nl', label: 'Nederlands' },
    { value: 'eo', label: 'Esperanto' },
    { value: 'et', label: 'Eesti' },
    { value: 'ee', label: 'Eʋegbe' },
    { value: 'fil', label: 'Filipino' },
    { value: 'fi', label: 'Suomi' },
    { value: 'fr', label: 'Français' },
    { value: 'fy', label: 'Frysk' },
    { value: 'gl', label: 'Galego' },
    { value: 'ka', label: 'ქართული' },
    { value: 'de', label: 'Deutsch' },
    { value: 'el', label: 'Ελληνικά' },
    { value: 'gn', label: "Avañe'ẽ" },
    { value: 'gu', label: 'ગુજરાતી' },
    { value: 'ht', label: 'Kreyòl ayisyen' },
    { value: 'ha', label: 'Hausa' },
    { value: 'haw', label: 'ʻŌlelo Hawaiʻi' },
    { value: 'he', label: 'עברית' },
    { value: 'hi', label: 'हिंदी' },
    { value: 'hmn', label: 'Hmong' },
    { value: 'hu', label: 'Magyar' },
    { value: 'is', label: 'Íslenska' },
    { value: 'ig', label: 'Igbo' },
    { value: 'ilo', label: 'Ilokano' },
    { value: 'id', label: 'Indonesia' },
    { value: 'ga', label: 'Gaeilge' },
    { value: 'it', label: 'Italiano' },
    { value: 'ja', label: '日本語' },
    { value: 'jv', label: 'Basa Jawa' },
    { value: 'kn', label: 'ಕನ್ನಡ' },
    { value: 'kk', label: 'Қазақша' },
    { value: 'km', label: 'ភាសាខ្មែរ' },
    { value: 'rw', label: 'Kinyarwanda' },
    { value: 'gom', label: 'कोंकणी' },
    { value: 'ko', label: '한국어' },
    { value: 'kri', label: 'Krio' },
    { value: 'ku', label: 'Kurdî' },
    { value: 'ckb', label: 'کوردی' },
    { value: 'ky', label: 'Кыргызча' },
    { value: 'lo', label: 'ລາວ' },
    { value: 'la', label: 'Latina' },
    { value: 'lv', label: 'Latviešu' },
    { value: 'ln', label: 'Lingála' },
    { value: 'lt', label: 'Lietuvių' },
    { value: 'lg', label: 'Luganda' },
    { value: 'lb', label: 'Lëtzebuergesch' },
    { value: 'mk', label: 'Македонски' },
    { value: 'mai', label: 'मैथिली' },
    { value: 'mg', label: 'Malagasy' },
    { value: 'ms', label: 'Melayu' },
    { value: 'ml', label: 'മലയാളം' },
    { value: 'mt', label: 'Malti' },
    { value: 'mi', label: 'Māori' },
    { value: 'mr', label: 'मराठी' },
    { value: 'mni-Mtei', label: 'মৈতৈলোন্' },
    { value: 'lus', label: 'Mizo' },
    { value: 'mn', label: 'Монгол' },
    { value: 'my', label: 'မြန်မာ' },
    { value: 'ne', label: 'नेपाली' },
    { value: 'no', label: 'Norsk' },
    { value: 'ny', label: 'Chichewa' },
    { value: 'or', label: 'ଓଡ଼ିଆ' },
    { value: 'om', label: 'Afaan Oromoo' },
    { value: 'ps', label: 'پښتو' },
    { value: 'fa', label: 'فارسی' },
    { value: 'pl', label: 'Polski' },
    { value: 'pt', label: 'Português' },
    { value: 'pa', label: 'ਪੰਜਾਬੀ' },
    { value: 'qu', label: 'Runasimi' },
    { value: 'ro', label: 'Română' },
    { value: 'ru', label: 'Русский' },
    { value: 'sm', label: 'Gagana Samoa' },
    { value: 'sa', label: 'संस्कृतम्' },
    { value: 'gd', label: 'Gàidhlig' },
    { value: 'nso', label: 'Sepedi' },
    { value: 'sr', label: 'Српски' },
    { value: 'st', label: 'Sesotho' },
    { value: 'sn', label: 'ChiShona' },
    { value: 'sd', label: 'سنڌي' },
    { value: 'si', label: 'සිංහල' },
    { value: 'sk', label: 'Slovenčina' },
    { value: 'sl', label: 'Slovenščina' },
    { value: 'so', label: 'Soomaali' },
    { value: 'es', label: 'Español' },
    { value: 'su', label: 'Basa Sunda' },
    { value: 'sw', label: 'Kiswahili' },
    { value: 'sv', label: 'Svenska' },
    { value: 'tl', label: 'Tagalog' },
    { value: 'tg', label: 'Тоҷикӣ' },
    { value: 'ta', label: 'தமிழ்' },
    { value: 'tt', label: 'Татарча' },
    { value: 'te', label: 'తెలుగు' },
    { value: 'th', label: 'ภาษาไทย' },
    { value: 'ti', label: 'ትግርኛ' },
    { value: 'ts', label: 'Xitsonga' },
    { value: 'tr', label: 'Türkçe' },
    { value: 'tk', label: 'Türkmençe' },
    { value: 'ak', label: 'Twi' },
    { value: 'uk', label: 'Українська' },
    { value: 'ur', label: 'اردو' },
    { value: 'ug', label: 'ئۇيغۇرچە' },
    { value: 'uz', label: "O'zbek" },
    { value: 'vi', label: 'Tiếng Việt' },
    { value: 'xh', label: 'isiXhosa' },
    { value: 'yi', label: 'ייִדיש' },
    { value: 'yo', label: 'Yorùbá' },
    { value: 'zu', label: 'isiZulu' }
  ],

  flags: {
    en_GB: 'GB',
    en: 'US',
    en_AU: 'AU',
    en_CA: 'CA',
    af: 'ZA',
    sq: 'AL',
    am: 'ET',
    ar: 'SA',
    hy: 'AM',
    as: 'IN',
    ay: 'BO',
    az: 'AZ',
    bm: 'ML',
    eu: 'ES',
    be: 'BY',
    bn: 'BD',
    bho: 'IN',
    bs: 'BA',
    bg: 'BG',
    ca: 'ES',
    ceb: 'PH',
    'zh-CN': 'CN',
    'zh-TW': 'TW',
    co: 'FR',
    hr: 'HR',
    cs: 'CZ',
    cy: 'GB_WLS',
    da: 'DK',
    dv: 'MV',
    doi: 'IN',
    nl: 'NL',
    et: 'EE',
    ee: 'GH',
    fil: 'PH',
    fi: 'FI',
    fr: 'FR',
    fy: 'NL',
    gl: 'ES',
    ka: 'GE',
    de: 'DE',
    el: 'GR',
    gn: 'PY',
    gu: 'IN',
    ht: 'HT',
    ha: 'NG',
    haw: 'US',
    he: 'IL',
    hi: 'IN',
    hmn: 'CN',
    hu: 'HU',
    is: 'IS',
    ig: 'NG',
    ilo: 'PH',
    id: 'ID',
    ga: 'IE',
    it: 'IT',
    ja: 'JP',
    jv: 'ID',
    kn: 'IN',
    kk: 'KZ',
    km: 'KH',
    rw: 'RW',
    gom: 'IN',
    ko: 'KR',
    kri: 'SL',
    ku: 'IQ',
    ckb: 'IQ',
    ky: 'KG',
    lo: 'LA',
    la: 'VA',
    lv: 'LV',
    ln: 'CD',
    lt: 'LT',
    lg: 'UG',
    lb: 'LU',
    mk: 'MK',
    mai: 'IN',
    mg: 'MG',
    ms: 'MY',
    ml: 'IN',
    mt: 'MT',
    mi: 'NZ',
    mr: 'IN',
    'mni-Mtei': 'IN',
    lus: 'IN',
    mn: 'MN',
    my: 'MM',
    ne: 'NP',
    no: 'NO',
    ny: 'MW',
    or: 'IN',
    om: 'ET',
    ps: 'AF',
    fa: 'IR',
    pl: 'PL',
    pt: 'PT',
    pa: 'IN',
    qu: 'PE',
    ro: 'RO',
    ru: 'RU',
    sm: 'WS',
    sa: 'IN',
    gd: 'GB_SCT',
    nso: 'ZA',
    sr: 'RS',
    st: 'LS',
    sn: 'ZW',
    sd: 'PK',
    si: 'LK',
    sk: 'SK',
    sl: 'SI',
    so: 'SO',
    es: 'ES',
    su: 'ID',
    sw: 'KE',
    sv: 'SE',
    tl: 'PH',
    tg: 'TJ',
    ta: 'IN',
    tt: 'RU',
    te: 'IN',
    th: 'TH',
    ti: 'ER',
    ts: 'ZA',
    tr: 'TR',
    tk: 'TM',
    ak: 'GH',
    uk: 'UA',
    ur: 'PK',
    ug: 'CN',
    uz: 'UZ',
    vi: 'VN',
    xh: 'ZA',
    yi: 'IL',
    yo: 'NG',
    zu: 'ZA'
  },

  //Custom theme loaded for default users
  customTheme: {
    dateFormat: 'DD/MM/YYYY',
    appearance: {
      value: 'light',
      color: '#FFFFFF',
      shade: '#DDDDDD',
      text: '#000'
    },
    navbar: '#FFFFFF',
    navbarText: '#000',
    sidebar: '#FFFFFF',
    sidebarText: '#000',
    accent: '#2ba9bf',
    header: '#2ba9bf',
    buttonStyle: '#f50057',
    buttonText: '#FFFFFF',
    highlighter: '#53cd53'
  },

  signinPath: `/identity/login`,
  studentRegister: `/student/register`,
  trialSignupPath: `/trial/signup`,
  trialVerifyPath: `/trial/verify`,

  userformPath: '/form',
  adminPath: basepath,
  adminDashboardPath: `${basepath}/dashboard`,
  resetPasswordPath: `${basepath}/password/reset`,
  resetPasswordLinkPath: `/password/reset/token`,
  generateLinkPath: `${basepath}/generateLink`,
  apiDocumentations: `${basepath}/apiDocumentations`,
  pedigreeToolPath: `${basepath}/pedigree`,
  pedigreeChartPath: `${basepath}/pedigree/:_id/`,
  pedigreeToolPath_v2: `${basepath}/pedigree_v2`,
  pedigreeChartPath_v2: `${basepath}/pedigree_v2/:_id/`,
  settingsPath: `${basepath}/settings`,
  errorPagePath: '/auth/error',
  sapioErrorPath: '/sapio/error',
  sapioCallbackPath: '/sapio/callback',

  medicarePath: `${basepath}/medicare`,
  medicareBillingPath: `${basepath}/medicare/:_id/`,

  carrierScreenPath: `${basepath}/carrier-screen`,
  carrierScreenReportPath: `${basepath}/carrier-screen/:_id`,

  patientPath: '/patients',
  patientDashboardPath: `/patients/dashboard`,
  patientProband: `/patients/proband`,
  patientPedigreeToolPath: `/patients/pedigree`,
  patientPedigreeChartPath: `/patients/pedigree/:_id/`,
  patientSettingsPath: `/patients/settings`,
  patientChatPath: `/patients/chat`,

  formCreationPath: `${basepath}/form-builder`,
  formSchemaViewPath: `${basepath}/form-builder/view/:_id`,
  newFormCreationPath: `${basepath}/form-builder/create`,
  formResponsesPath: `${basepath}/form-builder/responses/:_id`,
  formBuilderGenerateLinksPath: `${basepath}/form-builder/generate-links`,
  formProgressTracker: `${basepath}/form-builder/progress-tracker`,
  //WORKFLOWS PATH
  workflowCreationPath: `${basepath}/form-builder/workflows`,
  newWorkflowCreationPath: `${basepath}/form-builder/workflows/create`,
  workflowSchemaViewPath: `${basepath}/form-builder/workflows/view/:_id`,

  manageUserPath: `${basepath}/manageUsers`,

  dataExplorer: `${basepath}/dataExplorer`,

  desktopMigration: `${basepath}/desktopMigration`,
  // security monitor
  lockdownPath: `${basepath}/lockdown`,

  // Bulk-import wizard
  importWizardPath: `${basepath}/import`,
  importHistoryPath: `${basepath}/imports`,
  importJobDetailPath: `${basepath}/imports/:jobId`,

  pathwaysPath: `${basepath}/pathways`,
  pathwaysBoardsPath: `${basepath}/pathways/boards`,
  newPathwayPath: `${basepath}/pathways/new`,
  pathwayViewPath: `${basepath}/pathways/view/:_id`,
  pathwayBoardPath: `${basepath}/pathways/board/:_id`,
  probandInfoPath: `${basepath}/users`,
  calendarPath: `${basepath}/calendar`,
  clinicManagementPath: `${basepath}/clinic-management`,
  probandEditPath: `${basepath}/users/edit`,
  probandViewPath: `${basepath}/users/view`,
  familyMemberInfoPath: `${basepath}/users/:user_id/family/:member_id`,
  pregnancyInfoPath: `${basepath}/users/:user_id/pregnancy/:pregnancy_id`,

  // Letters Template
  letterTemplates: `${basepath}/settings/letter-templates`,
  letterTemplateCreationPath: `${basepath}/settings/letter-templates/create`,
  letterTemplateEditPath: `${basepath}/settings/letter-templates/edit/:template_id`,
  letterTemplateViewPath: `${basepath}/settings/letter-templates/view/:template_id`,

  customDiagnoses: {
    'breast-cancer': { value: 'Breast Cancer', status: true },
    'pancreatic-cancer': { value: 'Pancreatic Cancer', status: true },
    'colon-cancer': { value: 'Colon Cancer', status: true },
    'endometrial-cancer': {
      value: 'Endometrial (Uterus) cancer',
      status: true
    },
    'ovarian-cancer': { value: 'Ovarian Cancer', status: true },
    'prostate-cancer': { value: 'Prostate Cancer', status: true },
    polyps: { value: 'Polyps', status: true },
    'heart-problems': { value: 'Heart problems', status: true },
    'eye-problems': { value: 'Eye problems', status: true },
    'kidney-problems': { value: 'Kidney problems', status: true },
    'neurological-conditions': { value: 'Neurological', status: true },
    other: { value: 'Other', status: true },
    'blood-disorders': { value: 'Blood Disorders', status: true },
    stillbirth: { value: 'Stillbirth', status: true },
    'recurrent-misscarriage': {
      value: 'Recurrent Miscarriage',
      status: true
    },
    'congenital-abnormalities': {
      value: 'Congenital Abnormalities',
      status: true
    },
    hemophilia_a: {
      value: 'Hemophilia A',
      status: true
    },
    hemophilia_b: {
      value: 'Hemophilia B',
      status: true
    },
    fibrinogen_disorder: {
      value: 'Fibrinogen Disorder',
      status: true
    },
    von_willebrand_disease: {
      value: 'Von Willebrand Disease',
      status: true
    },
    glanzmann_thrombasthenia: {
      value: 'Glanzmann Thrombasthenia',
      status: true
    },
    bernard_soulier_syndrome: {
      value: 'Bernard Soulier Syndrome',
      status: true
    },
    hereditary_hemorrhagic_telangiectasia: {
      value: 'Hereditary Hemorrhagic Telangiectasia (HHT)',
      status: true
    },
    platelet_function_disorder: {
      value: 'Platelet Function Disorder',
      status: true
    },
    neutropenia: {
      value: 'Neutropenia',
      status: true
    },
    protein_c_deficiency: {
      value: 'Protein C Deficiency',
      status: true
    },
    protein_s_deficiency: {
      value: 'Protein S Deficiency',
      status: true
    },
    antithrombin_iii_deficiency: {
      value: 'Antithrombin III Deficiency',
      status: true
    },
    factor_v_leiden: {
      value: 'Factor V Leiden',
      status: true
    },
    prothrombin_gene_variant: {
      value: 'Prothrombin Gene Variant',
      status: true
    },
    'low_platelet_count_(thrombocytopenia)': {
      value: 'Low Platelet Count (Thrombocytopenia)',
      status: true
    },
    'blood_clot_(thrombosis)': {
      value: 'Blood Clot (Thrombosis)',
      status: true
    }
  },

  // Ordered by the symbol each value derives — everything drawing a '+' first, then
  // everything drawing a '-'. That keeps the zygosity terms adjacent and makes the
  // Edit Genotype list self-documenting. Presentation only: every consumer reads this
  // with find/some/forEach, so nothing depends on the order (TGCLOUD-1655).
  //
  // `label` is DUAL-PURPOSE — it is the dropdown text AND what renders on the pedigree
  // label and in the genotype record. So per-value guidance goes in `hint`, never
  // appended to `label`, or it would end up drawn on the chart.
  carrierStatuses: [
    { label: 'Carrier', value: 'carrier' },
    { label: 'Heterozygote', value: 'heterozygote' },
    { label: 'Homozygote', value: 'homozygote' },
    { label: 'Hemizygote', value: 'hemizygote' },
    {
      label: 'Homozygote or Compound Heterozygote',
      value: 'homozygote-or-compound-heterozygote',
      hint: 'use where the two cannot be distinguished'
    },
    { label: 'Non carrier', value: 'non-carrier' },
    { label: 'Normal', value: 'normal' },
    { label: 'Homozygous normal', value: 'homozygous-normal' }
  ],

  customDiagnosesTypes: [
    {
      type: 'Cancer',
      list: [
        'breast-cancer',
        'pancreatic-cancer',
        'colon-cancer',
        'endometrial-cancer',
        'ovarian-cancer',
        'prostate-cancer',
        'polyps'
      ]
    },
    {
      type: 'Reproductive Health',
      list: ['stillbirth', 'recurrent-misscarriage', 'congenital-abnormalities']
    },
    {
      type: 'Blood Disorders',
      list: [
        'blood-disorders',
        'hemophilia_a',
        'hemophilia_b',
        'fibrinogen_disorder',
        'von_willebrand_disease',
        'glanzmann_thrombasthenia',
        'bernard_soulier_syndrome',
        'hereditary_hemorrhagic_telangiectasia',
        'platelet_function_disorder',
        'neutropenia',
        'protein_c_deficiency',
        'protein_s_deficiency',
        'antithrombin_iii_deficiency',
        'factor_v_leiden',
        'prothrombin_gene_variant',
        'low_platelet_count_(thrombocytopenia)',
        'blood_clot_(thrombosis)'
      ]
    },
    {
      type: 'General',
      list: [
        'heart-problems',
        'eye-problems',
        'kidney-problems',
        'neurological-conditions',
        'other'
      ]
    }
  ],
  patientInitialContent: {
    formBuilder: {
      schemas: [],
      workflows: [],
      linksGenerated: []
    },
    pedigreeSelectedUsers: {
      family: [],
      selectedUser: {},
      diagnoses: [],
      phenotypes: []
    },
    settings: {
      chatFeature: true
    },
    probandUsers: [],
    selectedGroup: 'default'
  },

  consent: {
    default: `I am happy for you to disclose where you are calling from should someone other than myself answer the phone, and I consent to a message being left`
  },

  initialContent: {
    // used to collapse the previously clicked pannel
    previousSelectedId: -1,
    probandUsers: [],
    pedigreeUsers: [],
    pedigreeSelectedUsers: {
      family: [],
      selectedUser: {},
      diagnoses: []
    },
    medicareInvoices: [],
    carrierScreenReports: [],
    linksGenerated: [],
    settings: {
      preferences: {
        tableSettings: { rowsPerPage: 15, pageIndex: 0 },
        pedigreeSettings: {
          symbol_size: 45,
          fontSize: 16,
          horizontal_spacing: 100,
          vertical_spacing: 100
        },
        clinicalNotes: {}
      },
      systemFeatures: {
        FEATURE_FORM_BUILDER: false,
        FEATURE_DATA_EXPLORER: true,
        FEATURE_CLINIC_MANAGEMENT: false,
        FEATURE_FAMILY_HISTORY_QUESTIONNAIRE: true,
        FEATURE_FAMILY_RECORD_MANAGEMENT: true,
        FEATURE_CARRIER_STATUS_IN_CONDITION: false,
        FEATURE_SITE_DISEASE_COLOUR_KEY: false,
        FEATURE_FHQ_SPECIALITY_CONFIG: false,
        medicareFeature: false,
        carrierScreenFeature: false,
        pedigree_v2: true,
        pedigreeLabelEditForGSA: false
      },
      customisation: {
        isEnabled: false,
        customPersonalDetailsInstructions: '<p></p>',
        customFamilyMembersInstructions: '<p></p>',
        customPregnanciesInstructions: '<p></p>',
        customRiskSurveyInstructions: '<p></p>',
        customAdditionalQuestionsInstructions: '<p></p>',
        customConfirmDetailsInstructions: '<p></p>',
        questions: [],
        questionsTitle: '',
        saveSurnameInitials: false,
        saveDateAsYears: false,
        customConsent: `<strong>We may contact you if we need further details. <br/> We will not disclose where we are calling from to anyone apart from yourself, nor leave a message, without your permission.</strong>`,
        customDiagnoses: null
      },
      smtp: {
        hostname: '',
        secure: false,
        port: '',
        username: '',
        password: ''
      },
      chatFeature: true,
      recaptchaEnabled: false,
      googleTranslateEnabled: false,
      addressAutocompleteEnabled: true,
      emailTemplates: [],
      stripeConfig: {},
      auditLogs: [],
      // epic emr sys admin settings
      epicEmrIntegration: {
        enabled: false
      },
      // epic emr genetics settings
      epicEmrApi: {
        enabled: false,
        endpoint: ''
      }
    },
    clients: [],
    formBuilder: {
      schemas: [],
      workflows: [],
      linksGenerated: []
    }
  },

  user_status: {
    DEACTIVATED: 'DEACTIVATED',
    CREATED: 'CREATED',
    PENDING: 'PENDING',
    IN_PROGRESS: 'IN_PROGRESS',
    SUBMITTED: 'SUBMITTED',
    IMPORTED: 'IMPORTED'
  },
  client_status: {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    // Invited, password not yet set (TGCLOUD-1844)
    NEEDS_PASSWORD_RESET: 'NEEDS_PASSWORD_RESET'
  },
  twinTypeOptions: [
    { label: 'Identical', value: 'identical' },
    { label: 'Non-Identical', value: 'non-identical' }
  ],

  userTypes: {
    ADMIN: 'admin',
    GENETICS: 'genetics',
    GENETICS_SERVICE_ADMIN: 'geneticsServiceAdmin',
    GENETICS_USER: 'geneticsUser',
    PATIENT: 'patient',
    STUDENT: 'student'
  },
  userTypeOptions: [
    { label: 'System Admin', value: 'admin' },
    { label: 'Genetics Service', value: 'genetics' },
    { label: 'Genetics Service Admin', value: 'geneticsServiceAdmin' },
    { label: 'Genetics User', value: 'geneticsUser' }
  ],

  userTypeOptionsMap: {
    admin: 'System Admin',
    genetics: 'Genetics Service',
    geneticsServiceAdmin: 'Genetics Service Admin',
    geneticsUser: 'Genetics User',
    student: 'Student'
  },

  userRegionOptions: [
    { label: 'United States', value: 'US-NY' },
    { label: 'United Kingdom', value: 'GB' }
    // { label: 'Australia', value: null }
  ],

  raceOptions: [
    { label: 'White', value: 'white' },
    { label: 'Black / African-American', value: 'black' },
    { label: 'Hispanic / Latina-American', value: 'hispanic' },
    { label: 'Chinese-American', value: 'chinese' },
    { label: 'Japanese-American', value: 'japanese' },
    { label: 'Filipino-American', value: 'filipino' },
    { label: 'Hawaiian-American', value: 'hawaiian' },
    { label: 'Other Pacific Islander', value: 'pacific' },
    { label: 'Other Asian', value: 'asian' }
  ],

  biopsiesOptions: [
    { label: 'No biopsies', value: 0 },
    { label: '1 biopsies', value: 1 },
    { label: '2 or more biopsies', value: 2 }
  ],

  menstruationOptions: [
    { label: 'Less than 12 year old', value: 11 },
    { label: '12 through 13 year old', value: 12 },
    { label: 'Greater than 13 year old', value: 14 }
  ],

  flbOptions: [
    { label: 'No births', value: 0 },
    { label: 'Less than 20 year old', value: 19 },
    { label: '20 through 24 year old', value: 20 },
    { label: '25 through 29 year old', value: 25 },
    { label: '30 years old & greater', value: 30 }
  ],

  // Broad ancestry groupings, matching the categories PGS Catalog reports
  // ancestry_distribution coverage in — lets a clinician see (in a future
  // enhancement) whether a score was validated in a population like the
  // patient's, rather than free-texting an ancestry that can't be compared.
  prsAncestryOptions: [
    { label: 'Not reported / Unknown', value: 'unknown' },
    { label: 'European', value: 'european' },
    { label: 'East Asian', value: 'east-asian' },
    { label: 'South Asian', value: 'south-asian' },
    { label: 'African', value: 'african' },
    { label: 'African American / Afro-Caribbean', value: 'african-american' },
    { label: 'Hispanic / Latin American', value: 'hispanic-latin-american' },
    { label: 'Greater Middle Eastern', value: 'greater-middle-eastern' },
    { label: 'Oceanian', value: 'oceanian' },
    { label: 'Multiple / Mixed ancestry', value: 'multiple-mixed' }
  ],

  prsSourceOptions: [
    { label: 'Manually entered / estimated', value: 'manual' },
    { label: 'Clinical lab report (CLIA-validated)', value: 'clinical-lab' },
    { label: 'Direct-to-consumer report', value: 'dtc' },
    { label: 'Research / bioinformatics pipeline', value: 'research-pipeline' },
    { label: 'Other external report', value: 'other' }
  ],

  relativeOptions: [
    { label: '0 relatives', value: 0 },
    { label: '1 relatives', value: 1 },
    { label: '2 or more relatives', value: 2 }
  ],

  emailTemplatesActionMap: {
    new_custom_form_link_generated: 'New Custom Form link generated',
    new_link_generated: 'New Family History Questionnaire link generated',
    form_submitted: 'Questionnaire submitted (Send email to admin)',
    form_submitted_user: 'Questionnaire submitted (Send email to user)',
    questionnaire_submission_reminder: 'Automated Form reminder',
    new_client_created: 'New admin/genetics service user created',
    new_account_created: 'New patient/student/genetic user created',
    patient_registration: 'Patient Access Registration E-mail'
  },
  emailTemplatesAdminActionMap: {
    new_stripe_client_created: 'New stripe genetics service user created'
  },

  socketEvents: {
    physicianAssigned: 'physicianAssigned',
    message: 'message',
    incUnreadMsgCount: 'incUnreadMsgCount',
    joinRoom: 'joinRoom',
    sendGeneralMessage: 'sendGeneralMessage',
    sendMessage: 'sendMessage'
  },

  linkParameters: {
    cancer: 'cancer',
    cardiac: 'cardiac',
    blood: 'blood'
  },

  auditLogType: {
    pedigreeChart: 'PEDIGREE_CHART',
    clinicalRecord: 'CLINICAL_RECORD',
    personDetails: 'PERSON_DETAILS',
    riskFactors: 'RISK_FACTORS',
    phenotypes: 'PHENOTYPES',
    genotypes: 'GENOTYPES',
    diagnoses: 'DIAGNOSES',
    reproductive: 'REPRODUCTIVE',
    // TGCLOUD-1669 — every change to this person, across every section, in one
    // list. The route fans out server-side; there is no PERSON_ALL config.
    personAll: 'PERSON_ALL'
  },
  formTypeOptions: [
    { label: 'Family History Questionaire(FHQ)', value: 'FHQ' },
    { label: 'Custom Form', value: 'CUSTOM_FORM' }
  ]
});

// Maps a stored genotype carrierStatus value (e.g. 'non-carrier') to its
// human-friendly label (e.g. 'Non carrier') for display. Falls back to the
// raw value for anything not in the option list (e.g. the legacy 'Affected'
// value, which is already display-ready), and to '' when there is no status.
export const getCarrierStatusLabel = (value) => {
  if (!value) return '';
  const match = CONSTANTS.carrierStatuses.find((o) => o.value === value);
  return match ? match.label : value;
};

// Carrier statuses that are RECOGNISED but deliberately derive no +/- marker.
// 'Affected' is a phenotype statement, conveyed via diagnoses rather than as a carrier
// test result, so it produces no marker — and must not be reported as unrecognised
// (TGCLOUD-1647). It is also the only non-slug value in the system.
const MARKERLESS_CARRIER_STATUSES = ['Affected'];

// True when a genotype carries a carrier status TrakGene cannot interpret — e.g. a
// value an integration sent that is not in our vocabulary.
//
// Such a value is deliberately kept and rendered verbatim in the pedigree label, but
// no carrier symbol is derived from it, because there is no defensible mapping to
// carrier or non-carrier. That gap is otherwise invisible — the label looks correct —
// so the UI raises a warning against the genotype instead. Absent and markerless-by-
// design values are NOT unrecognised.
export const isUnrecognisedCarrierStatus = (value) => {
  if (!value || typeof value !== 'string') return false;
  const raw = value.trim();
  if (!raw) return false;
  if (MARKERLESS_CARRIER_STATUSES.includes(raw)) return false;
  return !CONSTANTS.carrierStatuses.some((o) => o.value === raw);
};

export const NAV_ITEMS = {
  general: [
    {
      path: CONSTANTS.adminDashboardPath,
      label: 'Home',
      icon: 'home'
    },
    {
      path: CONSTANTS.generateLinkPath,
      label: 'Collect Family History',
      icon: 'generate-link',
      id: 'tour-fhq'
    },
    {
      path: CONSTANTS.probandInfoPath,
      label: 'Search Family Records',
      icon: 'families',
      id: 'tour-proband'
    },
    {
      path: CONSTANTS.pedigreeToolPath,
      label: 'Pedigrees',
      icon: 'pedigree-tool',
      id: 'tour-pedigree'
    },
    {
      path: CONSTANTS.dataExplorer,
      label: 'Data Explorer',
      icon: 'data-explorer',
      id: 'tour-data-explorer'
    },
    {
      path: CONSTANTS.clinicManagementPath,
      label: 'Clinic Management',
      icon: 'clinic-management'
    }
    // {
    //   path: CONSTANTS.pedigreeToolPath_v2,
    //   label: 'Pedigree Chart',
    //   icon: 'pedigree-tool-v2'
    // }
  ],
  formBuilderAddon: [
    {
      path: CONSTANTS.formCreationPath,
      label: 'Create Forms',
      icon: 'assignment'
    }
  ],
  pathwaysAddon: [
    {
      path: CONSTANTS.pathwaysPath,
      label: 'Pathways',
      icon: 'pathways'
    }
  ],
  medicareAddon: [
    {
      path: CONSTANTS.medicarePath,
      label: 'Medicare Billing',
      icon: 'medicare',
      id: 'tour-pedigree'
    }
  ],
  carrierScreenAddon: [
    {
      path: CONSTANTS.carrierScreenPath,
      label: 'Carrier Screening Reports',
      icon: 'carrier-screen',
      id: 'tour-pedigree'
    }
  ],

  // Admin-only (System Admin), concatenated separately from NAV_ITEMS.admin
  // which is shared with genetics/GSA. See AdminPanel navItems.
  desktopMigration: [
    {
      path: CONSTANTS.desktopMigration,
      label: 'Desktop Migration',
      icon: 'desktop-migration'
    }
  ],

  admin: [
    { path: CONSTANTS.settingsPath, label: 'Settings', icon: 'settings' },
    {
      path: CONSTANTS.manageUserPath,
      label: 'Manage Users',
      icon: 'add-users'
    },
    {
      path: CONSTANTS.apiDocumentations,
      label: 'APIs',
      icon: 'api',
      id: 'api-documentations'
    }
  ],
  patient: [
    { path: CONSTANTS.patientDashboardPath, label: 'Home', icon: 'home' },
    {
      label: 'Family History',
      icon: 'families',
      id: 'tour-proband'
    },
    {
      path: CONSTANTS.patientChatPath,
      label: 'Chat',
      icon: 'chat',
      id: 'tour-chat'
    },
    {
      path: CONSTANTS.patientSettingsPath,
      label: 'Settings',
      icon: 'settings'
    }
  ],
  student: [
    { path: CONSTANTS.adminDashboardPath, label: 'Home', icon: 'home' },
    {
      path: CONSTANTS.pedigreeToolPath,
      label: 'Pedigree Tool',
      icon: 'pedigree-tool',
      id: 'tour-pedigree'
    }
  ]
};

export const STORAGE_TYPES = {
  GOOGLE: 'google',
  AWS: 'aws',
  AZURE: 'azure',
  // On-prem local disk. The value the backend already uses
  // (CONSTANTS.storageTypes.LOCAL_STORAGE, services/storageService.js
  // LocalStorage) and the value the 'Server File Storage' option in
  // settings/StorageConfig.jsx has always posted — it simply had no constant.
  SERVER: 'server'
};

export const PEDIGREE = {
  defaultModalValues: { open: false, title: '' },

  saveStatus: {
    SAVED: 'Saved',
    IN_PROGRESS: 'Autosaving'
  },

  defaultFormValues: {
    sex: 'unknown',
    type: 'standard',
    connection: 'partnership'
  },
  sexOptions: [
    { label: 'Male', value: 'male' },
    { label: 'Female', value: 'female' },
    { label: 'Unknown', value: 'unknown' }
  ],
  typeOptions: [
    { label: 'Standard', value: 'standard' },
    { label: 'Proband', value: 'proband' },
    { label: 'Deceased', value: 'deceased' },
    { label: 'Multiple', value: 'multiple' },
    { label: 'Pregnant', value: 'pregnant' }
  ],
  connectionOptions: [
    { label: 'Partnership', value: 'partnership' },
    { label: 'Separation', value: 'separation' },
    { label: 'Consanguineous', value: 'consanguineous' },
    { label: 'Siblings', value: 'siblings' }
  ],

  defaultLabelFilters: {
    firstName: true,
    lastName: true,
    age: true,
    upn: true,
    personNote: true,
    phenotypesName: true,
    phenotypesID: true,
    genotypesName: true,
    genotypesID: true,
    // ON by Tim's decision, 2026-08-17. Each of these was originally opt-IN on the reasoning that a
    // new label must not change an existing chart without the user asking. That reasoning has been
    // overridden deliberately: the default preset should show the clinically useful set out of the
    // box, and a site that wants less turns them off (or saves a System preset, which wins over
    // these built-in defaults).
    genotypeCarrierStatus: true,
    dob: true,
    dod: true,
    diseaseWithAge: true,
    hospitalNumber: true,
    // OFF, and unlike the keys above this is a considered exception rather than an oversight.
    //
    // It was absent entirely before 2026-08-17, which read as off everywhere via defaultVisibilityFor
    // — an omission rather than a decision, so it was briefly defaulted ON with the rest. Tim's
    // testing found the reason it had been off, and it stands: this prints an identifier under EVERY
    // individual in the family, which is noise most users do not want. The key stays PRESENT so the
    // off state is now a visible decision rather than a silent fall-through.
    externalPatientId: false,
    consultationDate: true,
    confirmedDiagnosis: true,
    tests: true,
    genesTested: true,
    variants: true,
    testResults: true,
    pedigreeText: true,
    // Reproductive (pregnancy + fetus annotations beside a fetus symbol). The first four rendered
    // UNCONDITIONALLY before there was any label group for them, so ON preserves what those charts
    // already showed and the group only ADDED the ability to turn them off.
    //
    // `fetusName` and `donorRole` are now ON too (Tim, 2026-08-17) — see the note above. donorRole
    // in particular is the only thing on the chart that says WHICH end of a donor line is the donor,
    // so having it off by default hid the direction of the relationship.
    pregnancyOutcome: true,
    gestationalAge: true,
    fetalSexMethod: true,
    fetusKaryotype: true,
    fetusName: true,
    donorRole: true,
    // Both default OFF. showAnalysisOverlay must be an explicit `false` (not
    // omitted) because the renderer treats `!== false` as on, so a missing
    // key would draw the overlay. standardNomenclature is read via Boolean(),
    // so `false` (or absent) reads as off — set explicitly to document intent.
    showAnalysisOverlay: false,
    standardNomenclature: false,
    // Record-status linkage badge (primary/secondary corner badge). Read via
    // Boolean(), default OFF: with it off no on-pedigree linkage symbol renders
    // (linkage remains in the sidebar Record Status panel). Opt-in like the
    // nomenclature/analysis overlays. See PLAN-linked-record-corner-badge.md.
    showRecordStatus: false,
    // Carrier marks. The renderer reads this as `!== false`, so ABSENT already meant on — but the
    // Labels panel reads the value itself, so the switch showed as off while marks were drawing.
    // Stating it explicitly settles that disagreement and is what Tim asked for; same reason
    // showAnalysisOverlay above is an explicit `false` rather than omitted.
    showCarrierMarks: true,
    // TGCLOUD-1465 — proband-only label control. Default OFF: it removes information from the chart,
    // so it must always be a deliberate choice. Read via Boolean(), stated explicitly for the same
    // reason showAnalysisOverlay is.
    probandOnlyLabels: false,
    carrierMarkStyle: 'border'
  },

  legendLabelFilters: {
    diseases: true
  }
};

// For phenotypes
export const PHENOTYPES_CONSTANTS = {
  initialPage: 0,
  maxLimit: 9,
  hpoBaseURL: '/terminology',
  searchHPOTerm: '/hp/search'
};

// For genotypes & diagnoses
export const HPO_CONSTANTS = {
  initialPage: 0,
  maxLimit: 9,
  hpoBaseURL: '/terminology/network',
  searchHPOTerm: '/search/:category',
  category: {
    gene: 'gene',
    disease: 'disease'
  }
};

export const GLOBAL_CONSTANTS = Object.freeze({
  tokenKey: 'fhq_token',
  noExpiry: 'no_expiry'
});

export const NOTE_TYPE_COLOURS = Object.freeze({
  Referral: '#0d8c9e',
  Appointment: '#53b382',
  Test: '#354051',
  Sample: '#d946a8',
  Treatment: '#3b82f6',
  Address: '#808080',
  'Clinical Note': '#f7b661',
  Contact: '#f6d956',
  Consent: '#87a878',
  'Tissue Pathology': '#8c7ae6',
  Process: '#bdbdbd',
  'Risk Score': '#354051',
  Disease: '#d94f4f',
  Phenotype: '#2BA9BF',
  Genotype: '#7546cc',
  Pregnancy: '#c2185b'
});

// Per-category label colour, paired with NOTE_TYPE_COLOURS by key. The bright
// accent above is kept for the card left bar, the tint and the filter dots, but
// as small bold label text most accents fall below the AA 4.5:1 floor on a
// near-white background. These are the same hue darkened until they clear AA (>=
// 4.5:1 vs white), so a coloured label stays legible. Categories whose accent
// already passes (Test, Risk Score, Genotype) reuse it unchanged. Used only when
// PEDIGREE_RECORD_SURFACES is on.
export const NOTE_TYPE_LABEL_COLOURS = Object.freeze({
  Referral: '#0c7f90',
  Appointment: '#3a825d',
  Test: '#354051',
  Sample: '#d02b99',
  Treatment: '#196cf4',
  Address: '#757575',
  'Clinical Note': '#aa6409',
  Contact: '#8a7307',
  Consent: '#5f7e51',
  'Tissue Pathology': '#7660e1',
  Process: '#747474',
  'Risk Score': '#354051',
  Disease: '#d53c3c',
  Phenotype: '#207f8f',
  Genotype: '#7546cc',
  Pregnancy: '#ad1457'
});

export const TABLE_CONSTANTS = {
  generatedLinks: 'generated_links_table',
  familyMembers: 'family_members_table',
  pedigree: 'pedigree_table',
  forms: 'forms_table',
  workflows: 'workflow_table',
  formBuilderGeneratedLinks: 'form_builder_generated_links_table',
  progressTracker: 'progress_tracker_table',
  medicareBilling: 'medicare_billing_table',
  carrierScreenReport: 'carrier_screen_report_table',
  users: 'users_table',
  disease: 'disease_table',
  announcementsManual: 'announcements_manual_table',
  announcementsAutomated: 'announcements_automated_table',
  monitorLogs: 'monitor_logs_table',
  emailTemplates: 'email_templates_table',
  activityLogs: 'activity_logs_table',
  dataExplorer: 'data_explorer_table',
  patientLinks: 'patient_links_table',
  viewOnlyfamilyDetails: 'view_only_family_details_table',
  viewOnlyPregnanciesDetails: 'view_only_pregnancies_details_table',
  details: 'details_table',
  pregDetails: 'preg_details_table',
  apiSetting: 'api_setting_table',
  customQuestions: 'custom_questions',
  ethnicity: 'ethnicity_table',
  religion: 'religion_table',
  terminologyCodeSystems: 'terminology_code_systems_table',
  // Distinct sessionStorage buckets — these three tables previously all shared
  // `users` (TABLE_CONSTANTS.users), so their saved page/search stomped each
  // other. Split during the MUI X migration (does not affect role-based access).
  clients: 'clients_table',
  securityGroups: 'security_groups_table',
  letterTemplates: 'letter_templates_table',
  userGroupsLicence: 'user_groups_licence_table',
  signupCodes: 'signup_codes_table',
  issuedLicences: 'issued_licences_table'
};
